module.exports = __webpack_public_path__ + "static/media/invIcon.5fcd6536.png";